
import Game from '../game';
import Minimap from '../minimap';
import WarFog from '../warFog';
import AlertGauge, { AlertGaugeParams } from '../alertGauge';
import Menu from '../ui/menu/menu';
import Scene, { SceneParams } from './scene';


export interface LevelSceneParams extends SceneParams {
  hasWarFog?: boolean;
}

export default class LevelScene extends Scene implements LevelSceneParams {
  minimap?: Minimap;
  warFog?: WarFog
  hasWarFog = false;

  alertGauge!: AlertGauge;

  constructor(params: SceneParams) {
    super(params);
    this.applyParams(params);
  }

  create(): Scene {
    super.create();
    Game.instance.controlSchemes.rts.enable();

    /* WARFOG */
    if (this.hasWarFog)
      this.warFog = new WarFog({ ctx: Game.instance.contexts.fogCanvas, width: this.width, height: this.height });

    /* Minimap */
    this.minimap = new Minimap({
      context: Game.instance.contexts.foregroundCanvas,
      width: Game.instance.canvas.mainCanvas.width / 4,
      height: Game.instance.canvas.mainCanvas.height / 4
    });

    /* AlertGauge */
    this.alertGauge = new AlertGauge({
      context: Game.instance.contexts.interfaceCanvas,
    } as AlertGaugeParams);


    return this;
  }

  tick(modifier: number): Scene {
    /* Camera management */
    this?.camera?.update(modifier);

    super.tick(modifier);

    /* Warfog */
    this?.warFog?.draw();

    /* interface */
    this.minimap?.draw();
    Game.instance.controlSchemes.rts.draw();


    if (Game.instance.paused)
      Game.instance.player.displayPause();
    Game.instance.player.displayResources();
    Object.values(Menu.openMenus).forEach(m => {
      m.draw();
    });

    if (this.alertGauge) {
      this.alertGauge.update(modifier);
      this.alertGauge.draw();
    }

    return this;
  }
}
